import { useLocation } from "react-router";
import { PAY_COMPONENT_IMPORT_BASE_PATH } from "../config";

/**
 * Derive the 0-based wizard step index from the current pathname.
 * Upload = 0, Map Columns = 1, Review = 2, Results/Errors = 3.
 */
export function useActiveWizardStepIndex(): number {
  const { pathname } = useLocation();
  const suffix = pathname.replace(PAY_COMPONENT_IMPORT_BASE_PATH, "");

  if (suffix === "/map") return 1;
  if (suffix === "/review") return 2;
  if (suffix === "/results" || suffix === "/errors") return 3;
  return 0;
}
